import { Injectable } from '@angular/core';
import { ApiInterface } from '../api-interface';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import {
  AtualizarUnidadeMedidaPadraoDTO,
  PageImplUnidadeMedidaDeItemEmpresaDTO,
  UnidadeMedidaDeItemDTO,
  UnidadeMedidaDeItemEmpresaDTO,
} from '../../models/configuracoes/unidade-de-medida.model';
import { ConfiguracaoGeralDTO, ConfiguracaoGeralResponseDTO } from '../../models/configuracoes/configuracao-geral.model';

@Injectable({
  providedIn: 'root',
})
export class UnidadeMedidaDeItemService implements ApiInterface {
  constructor(private apiService: ApiService) {}

  get<T>(
    url: string,
    data?: any
  ): Observable<PageImplUnidadeMedidaDeItemEmpresaDTO> {
    const queryParams = this.apiService.buildQueryParams(data);
    const patch = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<PageImplUnidadeMedidaDeItemEmpresaDTO>(patch);
  }

  getById<T>(url: string): Observable<UnidadeMedidaDeItemDTO> {
    return this.apiService.read<UnidadeMedidaDeItemDTO>(url);
  }

  /** Lista unidades de medida que a empresa ainda NAO possui (retorna array direto, nao paginado) */
  listarUnidadesAdicionaveis(): Observable<UnidadeMedidaDeItemDTO[]> {
    return this.apiService.read<UnidadeMedidaDeItemDTO[]>(
      '/unidaDeMedidaDeItemEmpresa/listaunidadesmedidanaoadastradas'
    );
  }

  /** Busca a unidade de medida padrao da empresa */
  buscarUnidadePadrao(): Observable<UnidadeMedidaDeItemEmpresaDTO> {
    return this.apiService.read<UnidadeMedidaDeItemEmpresaDTO>(
      '/unidaDeMedidaDeItemEmpresa/unidadeMedidaPadrao'
    );
  }

  /** Busca unidade de medida por nome (retorna paginado; usar content[0]) */
  buscarPorNome(nome: string): Observable<any> {
    return this.apiService.read<any>(
      `/unidadeMedidaItem/buscarPorNome?nome=${encodeURIComponent(nome)}`
    );
  }

  /** Busca a configuracao geral da empresa (retorna paginado) */
  buscarConfiguracaoGeral(): Observable<ConfiguracaoGeralResponseDTO> {
    return this.apiService.read<ConfiguracaoGeralResponseDTO>('/configuracaoGeral');
  }

  post<T>(
    url: string,
    data: UnidadeMedidaDeItemDTO | undefined
  ): Observable<UnidadeMedidaDeItemDTO> {
    return this.apiService.create<UnidadeMedidaDeItemDTO>(url, data);
  }

  put<T>(
    url: string,
    data: UnidadeMedidaDeItemDTO
  ): Observable<UnidadeMedidaDeItemDTO> {
    return this.apiService.update<UnidadeMedidaDeItemDTO>(url, data);
  }

  delete<T>(url: string): Observable<any> {
    return this.apiService.delete(url);
  }

  ativarOuInativar(id: number, data: UnidadeMedidaDeItemDTO): Observable<UnidadeMedidaDeItemDTO> {
    return this.apiService.update<UnidadeMedidaDeItemDTO>(`/unidadeMedidaItem/${id}`, data);
  }

  /**
   * Define a unidade de medida padrao da empresa via endpoint cirurgico.
   *
   * Endpoint: PATCH /configuracaoGeral/{configuracaoGeralId}/unidadeMedidaPadrao
   *
   * Apenas usuarios com categoriaAcessoMaster = true podem executar
   * (validado no backend — 422 caso contrario).
   *
   * @param configuracaoGeralId ID da ConfiguracaoGeral (path param)
   * @param dto Body com a unidadeMedidaDeItemId a ser marcada como padrao
   * @returns ConfiguracaoGeralDTO atualizado (contem unidadeMedidaPadraoId)
   *
   * Ver: vendas/docs/api/API_CONTRACT_unidade-medida-padrao.md
   */
  definirComoPadrao(
    configuracaoGeralId: number,
    dto: AtualizarUnidadeMedidaPadraoDTO
  ): Observable<ConfiguracaoGeralDTO> {
    return this.apiService.patch<ConfiguracaoGeralDTO>(
      `/configuracaoGeral/${configuracaoGeralId}/unidadeMedidaPadrao`,
      dto
    );
  }
}
